export function insertName(phrase: string, name: string): React$Node {
	return phrase.replace('[STUDENT NAME]', name)
}
